import { useState } from 'react'
import { personBackground, personLetter } from '../identity/personAvatar'

/**
 * A person's avatar: their profile photo when there is one, falling back to a lettered
 * tile — and falling back AGAIN if the photo URL 404s or is blocked, so a dead or
 * missing picture never renders as a broken-image icon (the reason AccountSection
 * guards its own <img> the same way).
 *
 * The tile is the email's first letter on a background derived from the address
 * (identity/personAvatar.ts) — owner, 2026-09-13: Apple 帳號沒有頭像, 用 email 首字 + 隨機
 * 背景的圓圈代替. It replaced two initials on a fixed self/peer colour: with Apple
 * accounts every person in a room is a tile, and a per-person colour is what tells
 * them apart. The frame (circle, rounded square, size) stays the surface's class.
 *
 * `referrerPolicy="no-referrer"` is required: Google's lh3 avatar host 403s a request
 * that carries our origin as the Referer.
 */
export function Avatar({
  picture,
  label,
  email,
  className = 'pmsg-avatar',
}: {
  picture: string | null | undefined
  /** What the surface calls this person — the letter's fallback when no address is known. */
  label: string
  /** The address, when the surface has it: the letter and the colours come from it. */
  email?: string | null | undefined
  className?: string
}) {
  const [broken, setBroken] = useState(false)
  if (picture && !broken) {
    return (
      <img
        className={className}
        src={picture}
        alt=""
        referrerPolicy="no-referrer"
        onError={() => setBroken(true)}
      />
    )
  }
  return (
    <span
      className={className}
      style={{ background: personBackground(email || label), color: 'var(--c11111b)' }}
      aria-hidden="true"
    >
      {personLetter(email, label)}
    </span>
  )
}
